import 'vendor-auto-grow-input'

class ExampleCategoryEditorView {
  constructor($el) {
    if (!$el.length) return
    this.$root = $el

    this.initSelect2()
  }

  // ---
  // Init
  // ---
  initSelect2() {
    const $canonicalResources = this.$root.find('.js-canonical-resources')
    $canonicalResources.select2()
  }
}

document.addEventListener('DOMContentLoaded', function () {
  return new ExampleCategoryEditorView($('.template-category-edit-view'))
})
